import Component from '../abstracts/Component';

export default class BenefitBarComponent extends Component {

  get SELECTORS() {
    return {
      main: '.js-benefit-bar'
    };
  }

  get CLASSES() {
    return {
      hidden: 'is-hidden',
      collapsed: 'collapsed'
    };
  }

  constructor() {
    super();
  }

  bindEvents() {
    let bar = document.querySelector(this.SELECTORS.main);
    if (bar === null) return;

    // this.$on(this.$customEvents.BURGER_EVENTS.click, () => {
    //   bar.classList.toggle(this.CLASSES.hidden)
    // });


    this.$on(this.$customEvents.BURGER_EVENTS.click, ({payload}) => {
      if (payload.menuIn) {
        $(bar).addClass(this.CLASSES.hidden)
      } else {
        $(bar).removeClass(this.CLASSES.hidden)
      }
    })

    // this.$on(this.$customEvents.HEADER_EVENTS.collapsed, () => {
    //   bar.classList.add(this.CLASSES.collapsed)
    // });

    // this.$on(this.$customEvents.HEADER_EVENTS.expanded, () => {
    //   bar.classList.remove(this.CLASSES.collapsed)
    // });


    

  }

  render() {
    this.bindEvents();
  }
}
